module.exports = __webpack_public_path__ + "img/peterandson.97be5b4f.png";